import ListAltIcon from "@material-ui/icons/ListAlt";
import React from "react";
import { Button, useTranslate } from "react-admin";

import { RefreshEntityCacheButton } from "../../../components/toolbars/RefreshEntityCacheButton";
import { CacheEntities } from "../../../entities/CacheEntities";
import { ConfigFileStatus } from "../../../entities/ConfigFileStatus";
import { useTerminalContext } from "../contexts/TerminalContext";
import { configApi } from "../services/configApi";
import { InfoBox } from "./InfoBox";

interface OtherControlsProps {
  terminalId: number;
}

export const OtherControls: React.FC<OtherControlsProps> = ({ terminalId }) => {
  const translate = useTranslate();
  const { configFileStatus } = useTerminalContext();
  const isProductionConfig = configFileStatus === ConfigFileStatus.production;

  const handleDownloadAllQrCodes = async () => {
    try {
      await configApi.downloadAllTerminalQrCodes(terminalId);
    } catch (error) {
      console.error("Failed to generate all QR codes:", error);
      alert(translate('osfc.storage_ui.other_controls.qr_failed', { error: error.message }));
    }
  };

  return (
    <InfoBox title={translate('osfc.storage_ui.other_controls.title')}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <RefreshEntityCacheButton
          cacheEntityId={CacheEntities.storage_module}
          title="osfc.buttons.storage_module.cache_refresh"
        />
      </div>
      {isProductionConfig && (
        <div style={{ marginTop: "8px" }}>
          <Button onClick={handleDownloadAllQrCodes}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "12px" }}>
              <ListAltIcon style={{ fontSize: "16px" }} />
              {translate('osfc.storage_ui.other_controls.generate_all_qr')}
            </div>
          </Button>
        </div>
      )}
    </InfoBox>
  );
};
